/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminOTGPolygonPoint
 */
export interface InputAdminOTGPolygonPoint {
    /**
     * 
     * @type {number}
     * @memberof InputAdminOTGPolygonPoint
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminOTGPolygonPoint
     */
    lng: number;
}

/**
 * Check if a given object implements the InputAdminOTGPolygonPoint interface.
 */
export function instanceOfInputAdminOTGPolygonPoint(value: object): boolean {
    if (!('lat' in value)) return false;
    if (!('lng' in value)) return false;
    return true;
}

export function InputAdminOTGPolygonPointFromJSON(json: any): InputAdminOTGPolygonPoint {
    return InputAdminOTGPolygonPointFromJSONTyped(json, false);
}

export function InputAdminOTGPolygonPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminOTGPolygonPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'],
        'lng': json['lng'],
    };
}

export function InputAdminOTGPolygonPointToJSON(value?: InputAdminOTGPolygonPoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

